import request from '@/utils/request'
// get options
export function getCheckoutGroup() {
  return request({
    url: '/cashier-service/v1/checkout-group',
    method: 'get'
  })
}
// get list
export function getCancelNoShowList(params) {
  return request({
    url: '/cashier-service/v1/cancel-fee-not-come',
    method: 'get',
    params: params
  })
}
